import React, { useState, useEffect } from "react";
import { platformClient } from "@/lib/musicApi";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";
import { useToast } from "@/contexts/ToastContext";
import { useTranslation } from "react-i18next";
import UpgradeToDonModal from "@/components/billing/UpgradeToDonModal";

/**
 * One-time Don upgrade popup (Step 39). Shown once to a new Boss subscriber after
 * checkout. Permanent dismiss flag stored on platform_users (don_upgrade_dismissed).
 * Mounted globally; self-decides visibility from a sessionStorage flag set at
 * checkout success plus the user's tier and dismissal flag. The confirmation UI is
 * the shared UpgradeToDonModal, so the popup, /pricing and Billing all use one copy
 * set, one proration figure and one upgrade call.
 */
export const DonUpgradePopup = () => {
  const { platformUser, isSubscriber, isDon, refresh } = usePlatformAuth();
  const toast = useToast();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const flag = sessionStorage.getItem("samtwo_show_don_upgrade") === "1";
    if (!flag || !platformUser) return;
    // Boss subscribers only; never for Don, never if permanently dismissed.
    if (isSubscriber && !isDon && !platformUser.don_upgrade_dismissed) {
      setOpen(true);
    }
    sessionStorage.removeItem("samtwo_show_don_upgrade");
  }, [platformUser, isSubscriber, isDon]);

  const dismiss = async () => {
    setOpen(false);
    try { await platformClient.post(`/subscriptions/dismiss-don-upgrade`, {}); await refresh(); } catch {}
  };
  const success = async () => {
    setOpen(false);
    toast.success(t("commerce.toastWelcomeDon"));
    await refresh();
  };
  const fail = () => toast.error(t("pricing.noticeUpgradeFail"));

  if (!platformUser) return null;
  return (
    <UpgradeToDonModal open={open} subscriptionId={platformUser.subscription_id}
      onClose={dismiss} onSuccess={success} onError={fail} testid="don-upgrade-popup" />
  );
};

export default DonUpgradePopup;
